import Button from '@mui/joy/Button';
import React from 'react';
import ToastMessage from '../../../../common/ToastMessage';
import userService from '../../../../services/userService/userService';
import useUserByEmail from '../../../../store/ReactQueries/users/useUserByEmail';
import { useNavigate } from 'react-router-dom';
import { StepsProp } from '../Components/SteppersData';
import { EndPoints } from '../../../../utils/apiEndpoints';
import { StorageItems } from '../../../../utils/storageItems';
import { useUserStore } from '../../../../store/useUserStore';
import { UserInterface } from '../../../../models/UserModel/User';
import { useDarkModeStore } from '../../../../store/useDarkModeStore';

interface ContinueButtonProps {
    activeStep: number;
    disabled?: boolean;
    filteredSteps: StepsProp<any>[];
    goToNextStep: () => void;
}

const ContinueButton = ({ activeStep, disabled = false, filteredSteps, goToNextStep }: ContinueButtonProps) => {
    const navigate = useNavigate();
    const { darkMode } = useDarkModeStore();
    const { user } = useUserStore();

    const { data: userByEmail } = useUserByEmail(user?.email ?? '');

    const updateUserApiCall = async () => {
        if (userByEmail) {

            const userData: UserInterface = {
                firstname: userByEmail.firstname,
                lastname: userByEmail.lastname,
                email: userByEmail.email,
                isActive: userByEmail.isActive,
            }
            try {
                await userService.Update(userData, false)
            } catch (error) {
                console.log(error);
                ToastMessage.Failed();
            }
        }
    }

    const isLastStep = filteredSteps.length - 1 === activeStep;

    const handleBtn = () => {
        if (isLastStep) {
            localStorage.setItem(StorageItems.FIRSTTIMELOGIN, 'false');
            // localStorage.setItem(StorageItems.ONBOARDSTEP, '');
            updateUserApiCall()

            navigate(EndPoints.ANALYTICS);
        }
        else goToNextStep();

    }

    return <div style={{ position: 'sticky', marginTop: 'auto', bottom: 20, textAlign: 'center' }}>
        <Button
            onClick={handleBtn}
            variant="plain"
            disabled={disabled}
            sx={{
                width: 200,
                height: 35,
                fontSize: 14,
                borderRadius: 10,
                color: darkMode ? 'black' : 'white',
                background: darkMode ? 'white' : '#333333',
                '&:hover': {
                    background: disabled ? '#b0b0b0' : darkMode ? '#f0f0f0' : '#555555',
                },
                '&:disabled': {
                    opacity: disabled ? .5 : 1,
                }
            }}
        >
            {isLastStep ? 'Finish' : 'Continue'}
        </Button>
    </div>
};

export default ContinueButton;